// The "Workflow" module was renamed to "Change Control" (#595). Some legacy
// dd_version_control rows still carry descriptions written before the rename
// (e.g. "Column updated via object workflow approval"). Scrub the word from any
// such text before it reaches the UI. Phrase-first for grammar; the word-boundary
// catch-all leaves identifiers like `workflow_id` untouched (`_` is a word char).
export function sanitizeChangeControl(text) {
  if (!text) return text;
  return String(text)
      .replace(/via (object )?workflow approval/gi, 'via Change Control')
      .replace(/\bworkflow\b/gi, 'Change Control');
}
